<div style="display: flex; flex-direction: column; flex: 1; margin-bottom: 12px">
  <div style="padding-right: 4px; display: flex; flex-direction: column; flex: 1">
    <div class="aems-card" style="flex: 1">
      <p class="mds-content"><strong>Part Details</strong></p>
      <hr class="m-b-12" />
      <div class="pure-g">
        <div class="m-b-4 pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div class="m-b-4">{{ partsManagementHeader.partGroupCode }} - {{ partsManagementHeader.partGroupDescription }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Part Group</div>
        </div>
        <div class="pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div>{{ partsManagementHeader.description }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Description</div>
        </div>
        <div class="pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div class="m-b-4">{{ partsManagementHeader.partManufacturerCode }} - {{ partsManagementHeader.partManufacturerName }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Manufacturer Code - Description</div>
        </div>
        <div class="pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div>{{ partsManagementHeader.quantity }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Quantity</div>
        </div>
      </div>
    </div>
  </div>
</div>
